var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg582ElektronischesTrschloss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 451.667,
    height: 451.667,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "background"), /*#__PURE__*/React.createElement("rect", {
    x: -1,
    y: -1,
    width: 446.718,
    height: 446.718,
    id: "canvas_background",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("ellipse", {
    ry: 213.823,
    rx: 213.741,
    id: "svg_5",
    cy: 226.958,
    cx: 223.877,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#f2f2f2",
    stroke: "null"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "svg_27"
  }, /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_1",
    height: 376.309,
    width: 178.636,
    y: 37.21,
    x: 151.239,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#e3e8ee"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    id: "svg_2",
    height: 49.352,
    width: 223.103,
    y: 132.83,
    x: 204.906,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    ry: 38.171,
    rx: 37.184,
    id: "svg_3",
    cy: 157.12,
    cx: 239.79,
    strokeOpacity: "null",
    strokeWidth: "null",
    fill: "#777f8e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#193351",
    id: "svg_4",
    d: "m429.286388,125.398069l-91.362053,0l0,-66.830528c0,-18.429634 -14.899584,-33.415656 -33.222919,-33.415656l-132.890118,0c-18.323335,0 -33.222919,14.986021 -33.222919,33.415656l0,334.154208c0,18.428851 14.899584,33.414873 33.222919,33.414873l132.890896,0c18.322556,0 33.22214,-14.986021 33.22214,-33.415656l0,-200.492368l91.362053,0c4.590956,0 8.305924,-3.73652 8.305924,-8.35411l0,-50.123092c0,-4.616807 -3.714968,-8.353327 -8.305924,-8.353327zm-107.973123,267.322897c0,9.210118 -7.454075,16.707436 -16.61107,16.707436l-132.890896,0c-9.156995,0 -16.61107,-7.497318 -16.61107,-16.707436l0,-334.153425c0,-9.210118 7.454075,-16.707436 16.61107,-16.707436l132.890896,0c9.156995,0 16.61107,7.497318 16.61107,16.707436l0,66.830528l-46.102669,0c-9.481695,-10.670736 -22.727414,-16.707436 -36.95346,-16.707436c-27.48033,0 -49.833989,22.483339 -49.833989,50.123092c0,27.639753 22.353659,50.123092 49.833989,50.123092c14.226825,0 27.471765,-6.0367 36.95346,-16.707436l46.102669,0l0,200.491585zm99.667978,-217.199804l-149.688844,0c-2.603826,0 -5.053478,1.2241 -6.626363,3.320655c-6.391209,8.509178 -16.019291,13.387565 -26.409678,13.387565c-18.322556,0 -33.222919,-14.986021 -33.222919,-33.415656s14.900363,-33.415656 33.222919,-33.415656c10.390387,0 20.01769,4.878387 26.409678,13.387565c1.573664,2.096555 4.023316,3.320655 6.626363,3.320655l149.688844,0l0,33.414873z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#777f8e",
    id: "svg_6",
    d: "m188.422368,267.413235c0,4.61759 3.714968,8.35411 8.305924,8.35411l83.056908,0c4.590956,0 8.305924,-3.73652 8.305924,-8.35411c0,-4.61759 -3.714968,-8.35411 -8.305924,-8.35411l-83.056908,0c-4.590956,0.000783 -8.305924,3.737303 -8.305924,8.35411z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#777f8e",
    id: "svg_7",
    d: "m279.784421,325.890437l-83.056129,0c-4.590956,0 -8.305924,3.73652 -8.305924,8.35411s3.714968,8.35411 8.305924,8.35411l83.056908,0c4.590956,0 8.305924,-3.73652 8.305924,-8.35411s-3.715747,-8.35411 -8.306703,-8.35411z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f03",
    id: "svg_8",
    d: "m384.441248,277.480928c-3.658126,-2.765385 -8.864999,-2.022937 -11.631564,1.664243c-2.749435,3.68718 -2.011269,8.925043 1.654644,11.699043c8.443746,6.37973 13.286209,16.120056 13.286209,26.733621c0,10.605733 -4.833897,20.34606 -13.261292,26.725789c-3.665913,2.774 -4.404079,8.003248 -1.646858,11.690428c1.630506,2.18662 4.120648,3.336318 6.642715,3.336318c1.735624,0 3.487601,-0.546655 4.980284,-1.68069c12.645375,-9.56098 19.89622,-24.164029 19.89622,-40.072629c0,-15.915648 -7.259411,-30.527313 -19.920358,-40.096124z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    fill: "#f03",
    id: "svg_9",
    d: "m408.473689,254.058564c-3.487601,-2.994072 -8.719391,-2.594653 -11.703979,0.921795c-2.984589,3.507833 -2.571122,8.777806 0.916478,11.771878c14.794465,12.726566 23.286489,31.253314 23.286489,50.824815c0,19.579333 -8.492023,38.106081 -23.295054,50.824815c-3.487601,3.001903 -3.901067,8.27266 -0.925043,11.780493c1.646858,1.933655 3.974261,2.929068 6.318794,2.929068c1.913937,0 3.828652,-0.660998 5.393751,-1.998658c18.509434,-15.9086 29.118623,-39.060769 29.118623,-63.534935c0.000779,-24.466334 -10.60841,-47.619287 -29.110057,-63.519272z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg582ElektronischesTrschloss);
export default __webpack_public_path__ + "static/media/582 Elektronisches Türschloss.9db1e72e40efb60c6f165e9103d1fe23.svg";
export { ForwardRef as ReactComponent };